import { LoadingButton } from '@atlaskit/button';
import LinkIcon from '@atlaskit/icon/glyph/link';
import UnlinkIcon from '@atlaskit/icon/glyph/unlink';
import Tooltip from '@atlaskit/tooltip';
import { Dispatch, SetStateAction } from 'react';
import styled from 'styled-components';

import { useSyncUtils } from '../../../../hooks/useSyncUtils';
import { ImportMapping } from '../../../../types';
import { TogglTimeEntry } from '../../../../types/toggl-api';

interface SyncButtonCellProps {
  isSynced: boolean;
  issueKey: string | undefined;
  mapping?: ImportMapping | null;
  timeEntry: TogglTimeEntry;
  tooltip: string;
  setSelected: Dispatch<SetStateAction<number[]>>;
}

export function SyncButtonCell({
  isSynced,
  issueKey,
  mapping,
  timeEntry,
  tooltip,
  setSelected,
}: SyncButtonCellProps) {
  const { syncOneEntry, isLoading, unsyncEntry } = useSyncUtils();

  return (
    <Tooltip content={tooltip} position="top-start">
      <SyncButton
        appearance="default"
        isDisabled={isButtonDisabled(
          isSynced,
          timeEntry.duration < 60,
          Boolean(issueKey)
        )}
        isLoading={isLoading}
        iconBefore={
          mapping ? (
            <UnlinkIcon label="Unsync" size="medium" />
          ) : (
            <LinkIcon label="Sync" size="medium" />
          )
        }
        onClick={(e) => {
          e.stopPropagation();
          if (mapping?.jiraIssueKey) {
            void unsyncEntry(mapping);
          } else if (issueKey) {
            void (async () => {
              const { failedCount } = await syncOneEntry({
                timeEntry,
                issueKey,
              });
              if (!failedCount) {
                setSelected((prev) => prev.filter((s) => s !== timeEntry.id));
              }
            })();
          }
        }}
      />
    </Tooltip>
  );
}

const SyncButton = styled(LoadingButton)`
  padding: 0 4px !important;
`;

function isButtonDisabled(
  isSynced: boolean,
  isTooShort: boolean,
  hasIssueKey: boolean
) {
  if (isSynced) {
    return false;
  }
  if (isTooShort) {
    return true;
  }
  return !hasIssueKey;
}
